import { COLORS } from 'src/styles/colors';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  link: { color: COLORS.blue['700'] },
});
